import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AutocompleteFn, AutocompleteOptions, AutocompleteResponse } from '../form-fields';
import { CrmApiService } from '@shared/core';
import { DEFAULT_REQUEST_PARAMS } from '../../core/types';

@Injectable({
  providedIn: 'root',
})
export class FormAutocompleteService extends CrmApiService {
  getAutocompleteFn(path: string): AutocompleteFn {
    return (query: string): Observable<AutocompleteOptions> => {
      return this.api
        .get<AutocompleteResponse>(`${this.baseEndpoint}${path}`, {
          params: { query },
          ...DEFAULT_REQUEST_PARAMS,
        })
        .pipe(
          map(response => response.data),
          catchError(() => of([])),
        );
    };
  }
}
